// export const APIENDPOINT = "http://localhost:3100"
export const APIENDPOINT = "https://schoolapi.namtechsolutions.in"